<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_9">CONTENTS</a></h2><a id="page_9">
</a><p class="tocb"><a id="page_9"></a><a href="#/xhtml/intro#intro">Introduction: Mindset Is Not Just for Athletes, Academics, and Cave-Dwelling Mystics</a></p>
<p class="toc"><a href="#/xhtml/ch01#ch01"><strong>Chapter One:</strong> The Purpose Principle</a></p>
<p class="toc"><span href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong>Chapter Two:</strong> The Promises Principle</span></p>
<p class="toc"><span href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>Chapter Three:</strong> The Projects Principle</span></p>
<p class="toc"><span href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>Chapter Four:</strong> The Persuasion Principle</span></p>
<p class="toc"><span href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>Chapter Five:</strong> The Praising Principle</span></p>
<p class="toc"><span href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>Chapter Six:</strong> The Perseverance Principle</span></p>
<p class="tocb"><a href="#/xhtml/ch01#ch01"><strong>Chapter Seven:</strong> The Preparation Principle</a></p>
<p class="toc"><span href="#/xhtml/concl#concl" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/author#author" title="Link target outside of Sample">About the Author</span><a id="page_10"></a></p><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?15674b64